import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1628473673 from "../../../../../packages/component/src/components/calendar/demo/demo1.js?loadDemo";
import legacyImportDemo_3314122570 from "../../../../../packages/component/src/components/calendar/demo/demo2.js?loadDemo";
import legacyImportDemo_3890984011 from "../../../../../packages/component/src/components/calendar/demo/demo3.js?loadDemo";
import legacyImportDemo_2013423436 from "../../../../../packages/component/src/components/calendar/demo/demo4.js?loadDemo";
import legacyImportDemo_3024240717 from "../../../../../packages/component/src/components/calendar/demo/demo5.js?loadDemo";
import legacyImportDemo_3581271118 from "../../../../../packages/component/src/components/calendar/demo/demo6.js?loadDemo";
import legacyImportDemo_1567694671 from "../../../../../packages/component/src/components/calendar/demo/demo7.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1628473673,
  legacyImportDemo_3314122570,
  legacyImportDemo_3890984011,
  legacyImportDemo_2013423436,
  legacyImportDemo_3024240717,
  legacyImportDemo_3581271118,
  legacyImportDemo_1567694671,
  React
};